import {
  type Column as MultiTableColumn,
  type Row as MultiTableRow,
} from '@myre/ui-primitive-multi-table';

export type Column<Key extends string> = MultiTableColumn<Key>;

export type Row<Key extends string> = MultiTableRow<Key>;

export type PaginationList = { currentPage: number; totalPages: number };

export enum Theme {
  StandaloneCard = 'card',
  PartOfComponent = 'component',
}
